/**
 * PDP buy-box cross-sell — carousel + AJAX add (theme ProductForm parity).
 */
(function () {
  const SECTION_ID = "ro-pdp-buybox-cross-sell-api";

  function initRoot(root) {
    if (!root || root._roPdpBuyboxInitialized) return;
    root._roPdpBuyboxInitialized = true;

    upgradeLoaderButtons(root);
    bindRootEvents(root);

    const slides = Array.from(root.querySelectorAll("[data-slide]"));
    if (slides.length > 0) {
      initCarousel(root, slides);
      return;
    }

    if (root.tagName === "RO-PDP-BUYBOX-CROSS-SELL") {
      loadRecommendations(root);
    }
  }

  function upgradeLoaderButtons(root) {
    root.querySelectorAll("[data-ro-pdp-buybox-add]").forEach((button) => {
      if (button.getAttribute("is") !== "loader-button") {
        button.setAttribute("is", "loader-button");
      }
      customElements.upgrade(button);
    });
  }

  function bindRootEvents(root) {
    if (root._roPdpBuyboxEventsBound) return;
    root._roPdpBuyboxEventsBound = true;

    root.addEventListener("click", (event) => {
      const addBtn = event.target.closest("[data-ro-pdp-buybox-add]");
      if (addBtn && root.contains(addBtn)) {
        onAddClick(event, addBtn);
        return;
      }

      const prevBtn = event.target.closest("[data-ro-pdp-buybox-prev]");
      if (prevBtn && root.contains(prevBtn)) {
        event.preventDefault();
        root._roPdpBuyboxGo?.(-1);
        return;
      }

      const nextBtn = event.target.closest("[data-ro-pdp-buybox-next]");
      if (nextBtn && root.contains(nextBtn)) {
        event.preventDefault();
        root._roPdpBuyboxGo?.(1);
      }
    });
  }

  function measureCarousel(root, slideElements) {
    const viewport = root.querySelector(".ro-pdp-buybox-cross-sell__viewport");
    const track = root.querySelector("[data-ro-pdp-buybox-cross-sell-track]");
    if (!viewport || !track || slideElements.length === 0) return 0;

    viewport.style.width = "";
    slideElements.forEach((slide) => {
      slide.style.flexBasis = "";
      slide.style.width = "";
      slide.style.maxWidth = "";
    });

    let slideWidth = 0;
    slideElements.forEach((slide) => {
      slideWidth = Math.max(slideWidth, Math.ceil(slide.getBoundingClientRect().width));
    });

    if (!slideWidth) return 0;

    viewport.style.width = `${slideWidth}px`;
    slideElements.forEach((slide) => {
      slide.style.flexBasis = `${slideWidth}px`;
      slide.style.width = `${slideWidth}px`;
      slide.style.maxWidth = `${slideWidth}px`;
    });

    track.style.width = `${slideWidth * slideElements.length}px`;
    return slideWidth;
  }

  function initCarousel(root, slides) {
    const track = root.querySelector("[data-ro-pdp-buybox-cross-sell-track]");
    const viewport = root.querySelector(".ro-pdp-buybox-cross-sell__viewport");
    const prevBtn = root.querySelector("[data-ro-pdp-buybox-prev]");
    const nextBtn = root.querySelector("[data-ro-pdp-buybox-next]");
    let index = 0;
    let slideWidth = 0;

    const remeasure = () => {
      slideWidth = measureCarousel(root, slides);
      update();
      if (!slideWidth) {
        requestAnimationFrame(() => {
          slideWidth = measureCarousel(root, slides);
          update();
        });
      }
    };

    function update() {
      if (!track || !slideWidth) return;
      track.style.transform = `translate3d(-${index * slideWidth}px, 0, 0)`;
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    root._roPdpBuyboxGo = (delta) => {
      if (slides.length <= 1) return;
      index = Math.max(0, Math.min(slides.length - 1, index + delta));
      update();
    };

    remeasure();

    if (root._roPdpBuyboxResizeObserver) {
      root._roPdpBuyboxResizeObserver.disconnect();
    }

    const row = root.querySelector(".ro-pdp-buybox-cross-sell__row");
    const observeTarget = row || viewport;

    if (observeTarget && typeof ResizeObserver !== "undefined") {
      root._roPdpBuyboxResizeObserver = new ResizeObserver(() => {
        const prevIndex = index;
        remeasure();
        index = Math.min(prevIndex, slides.length - 1);
        update();
      });
      root._roPdpBuyboxResizeObserver.observe(observeTarget);
    }
  }

  async function loadRecommendations(root) {
    const routes = window.themeVariables?.routes;
    const productId = root.getAttribute("product-id");
    if (!productId || !routes?.productRecommendationsUrl) return;

    const heading = root.dataset.heading || "KUNDEN KAUFTEN AUCH:";
    const limit = parseInt(root.dataset.limit || "10", 10);
    const btnLabel = root.dataset.btnLabel || "HINZUFÜGEN";
    const sectionId = root.getAttribute("section-id") || SECTION_ID;

    let slidesContainer = null;

    for (const intent of ["complementary", "related"]) {
      slidesContainer = await fetchSlides(
        routes.productRecommendationsUrl,
        productId,
        sectionId,
        limit,
        intent
      );
      if (slidesContainer?.querySelector("[data-slide]")) break;
    }

    if (!slidesContainer?.querySelector("[data-slide]")) return;

    const slides = Array.from(slidesContainer.querySelectorAll("[data-slide]"));
    if (slides.length === 0) return;

    buildFromSlides(root, slides, heading, btnLabel);
    upgradeLoaderButtons(root);
    initCarousel(root, Array.from(root.querySelectorAll("[data-slide]")));
    root.removeAttribute("hidden");
  }

  async function fetchSlides(recommendationsUrl, productId, sectionId, limit, intent) {
    const url = new URL(recommendationsUrl, window.location.origin);
    url.searchParams.set("product_id", productId);
    url.searchParams.set("section_id", sectionId);
    url.searchParams.set("limit", String(limit));
    url.searchParams.set("intent", intent);

    try {
      const response = await fetch(url.toString());
      if (!response.ok) return null;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.querySelector("[data-ro-pdp-buybox-cross-sell-slides]");
    } catch (error) {
      console.warn("[ro-pdp-buybox-cross-sell] fetch failed", error);
      return null;
    }
  }

  function buildFromSlides(root, slides, heading, btnLabel) {
    const headingEl = document.createElement("p");
    headingEl.className = "ro-pdp-buybox-cross-sell__heading";
    headingEl.textContent = heading;

    const rail = document.createElement("div");
    rail.className = "ro-pdp-buybox-cross-sell__rail";

    const layout = document.createElement("div");
    layout.className = "ro-pdp-buybox-cross-sell__layout";

    const row = document.createElement("div");
    row.className = "ro-pdp-buybox-cross-sell__row";

    const viewport = document.createElement("div");
    viewport.className = "ro-pdp-buybox-cross-sell__viewport";

    const track = document.createElement("div");
    track.className = "ro-pdp-buybox-cross-sell__track";
    track.setAttribute("data-ro-pdp-buybox-cross-sell-track", "");

    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      const label = clone.querySelector(".ro-pdp-buybox-cross-sell__add-label");
      if (label && btnLabel) label.textContent = btnLabel;
      track.appendChild(clone);
    });

    viewport.appendChild(track);
    row.appendChild(viewport);

    if (slides.length > 1) {
      const nav = document.createElement("div");
      nav.className = "ro-pdp-buybox-cross-sell__nav";
      nav.innerHTML = `
        <button type="button" class="ro-pdp-buybox-cross-sell__arrow ro-pdp-buybox-cross-sell__arrow--prev" data-ro-pdp-buybox-prev aria-label="Previous recommendation" disabled>
          <svg viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.5 1L1.5 6L6.5 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button type="button" class="ro-pdp-buybox-cross-sell__arrow ro-pdp-buybox-cross-sell__arrow--next" data-ro-pdp-buybox-next aria-label="Next recommendation">
          <svg viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      `;
      row.appendChild(nav);
    }

    layout.appendChild(row);
    rail.appendChild(layout);

    root.innerHTML = "";
    root.append(headingEl, rail);
  }

  async function onAddClick(event, button) {
    event.preventDefault();

    const variantId = button.getAttribute("data-variant-id");
    const routes = window.themeVariables?.routes;
    const settings = window.themeVariables?.settings;

    if (!variantId || !routes?.cartAddUrl || button.getAttribute("aria-busy") === "true") {
      return;
    }

    if (settings?.cartType === "page" || settings?.pageType === "cart") {
      window.location.href = `${routes.cartAddUrl}?id=${variantId}&quantity=1`;
      return;
    }

    button.setAttribute("aria-busy", "true");
    button.setAttribute("disabled", "disabled");

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");
    formData.append("sections", "mini-cart");

    try {
      const response = await fetch(`${routes.cartAddUrl}.js`, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const responseJson = await response.json();
      button.removeAttribute("aria-busy");
      button.removeAttribute("disabled");

      if (!response.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            detail: {
              status: "error",
              error: responseJson.description || "",
            },
          })
        );
        return;
      }

      const variant = Object.prototype.hasOwnProperty.call(responseJson, "items")
        ? responseJson.items[0]
        : responseJson;

      button.closest("[data-ro-pdp-buybox-root]")?.dispatchEvent(
        new CustomEvent("variant:added", {
          bubbles: true,
          detail: { variant },
        })
      );

      const cartResponse = await fetch(`${routes.cartUrl}.js`);
      const cartContent = await cartResponse.json();
      cartContent.sections = responseJson.sections;

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: settings?.cartType === "drawer",
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: { status: "success", error: "" },
        })
      );
    } catch (error) {
      button.removeAttribute("aria-busy");
      button.removeAttribute("disabled");
      console.warn("[ro-pdp-buybox-cross-sell] add failed", error);
    }
  }

  class RoPdpBuyboxCrossSell extends HTMLElement {
    connectedCallback() {
      initRoot(this);
    }
  }

  if (!customElements.get("ro-pdp-buybox-cross-sell")) {
    customElements.define("ro-pdp-buybox-cross-sell", RoPdpBuyboxCrossSell);
  }

  function boot() {
    document.querySelectorAll("[data-ro-pdp-buybox-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
